<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-block z-0">
            <ProjectWorklogs :projectId="id" :showMaterialExpenses="true" :showRateTime="true" :showNavigation="true"
              :projectPlanning="true" :showFilters="false"></ProjectWorklogs>
          </div>
          <div class="card-block card-block-mb">
            <VacationPlanner :projectId="id"></VacationPlanner>
          </div>
          <div class="card-block card-block-mb">
            <button @click="showTimeline = !showTimeline" class="btn btn-info btn-sm">Show timeline</button>
            <div v-if="showTimeline">
              <PlannedPeriodTimeline :projectId="id"></PlannedPeriodTimeline>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.z-0 {
  z-index: 0;
}
</style>

<script>
import { mapActions } from 'vuex';
import ProjectWorklogs from './ProjectWorklogs.vue';
import VacationPlanner from './VacationPlanner.vue';
import PlannedPeriodTimeline from './PlannedPeriodTimeline.vue';

export default {
  name: 'ProjectTabLogs',
  components: {
    ProjectWorklogs,
    VacationPlanner,
    PlannedPeriodTimeline,
  },
  props: {
    id: { type: Number }
  },
  data() {
    return {
      showTimeline: false,
    }
  },
  methods: {
    ...mapActions('JiraProjects', ['LOAD_JIRA_PROJECTS']),
    ...mapActions('JiraUsers', ['LOAD_JIRA_USERS']),
    ...mapActions('WorkloadPlans', ['LOAD_PROJECT_PLANNED_WORKLOADS']),
  },
  created() {
    this.LOAD_JIRA_PROJECTS();
    this.LOAD_JIRA_USERS();
    this.LOAD_PROJECT_PLANNED_WORKLOADS({ id: this.id });
  },
  mounted() {
  },
};
</script>
